import EmptyContent from 'src/components/empty-content';
import Scrollbar from 'src/components/scrollbar';
import { SkeletonConversationItem } from 'src/components/skeleton';
import { useLocales } from 'src/locales';
import { PastNotesItem } from './PastNotesItem';
import { PastSessionsItem } from './PastSessionsItem';
import { useVoicePastSessionsQuery } from './useVoicePastSessionsQuery';

const ITEM_HEIGHT = 162;

export const PastSessionsList = ({
  channelId,
  handleClose,
}: { channelId: string; handleClose: () => void }) => {
  const { isFetching, sessions, notes } = useVoicePastSessionsQuery({
    channelId,
  });
  const { translate } = useLocales();

  if (isFetching) {
    return (
      <>
        <SkeletonConversationItem />
        <SkeletonConversationItem />
      </>
    );
  }

  if (!sessions?.length && !notes?.length) {
    return (
      <EmptyContent
        sx={{ height: 300 }}
        title={translate('communicate.past_sessions.empty')}
        description={translate('communicate.past_sessions.empty_text')}
        img="/assets/illustrations/illustration_empty_content.svg"
      />
    );
  }

  return (
    <Scrollbar sx={{ maxHeight: ITEM_HEIGHT * 2, height: 'auto' }}>
      {sessions?.map((session) => (
        <PastSessionsItem
          key={session._id}
          session={session}
          channelId={channelId}
          handleClose={handleClose}
        />
      ))}
      {notes?.map((note) => (
        <PastNotesItem
          key={note._id}
          note={note}
          channelId={channelId}
          handleClose={handleClose}
        />
      ))}
    </Scrollbar>
  );
};
